import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SearchOperators, ElasticExpedientesByKeyword } from '../../../core/model/inventories';
import { InventariosService } from '../../../core/services/inventarios.service';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { Subscription } from 'rxjs';
import { HighlightService } from '../../../core/services/highlight.service';
import { BsModalService } from 'ngx-bootstrap';
import { BusquedaOficinaComponent } from '../busqueda-oficina/busqueda-oficina.component';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-busqueda-inventario',
  templateUrl: './busqueda-inventario.component.html',
  styleUrls: ['./busqueda-inventario.component.css']
})
export class BusquedaInventarioComponent implements OnInit, OnDestroy {

  @ViewChild('inventorySearchTextInput') inventorySearchInput: ElementRef;
  @ViewChild('uldropdown') uldropdown: ElementRef;
  @ViewChild('divDropdow') divDropdow: ElementRef;

  @Input() isMenu = false;

  @Output() searchTextFinder = new EventEmitter<ElasticExpedientesByKeyword>();

  inventoryTextField = 'inventoryTextField';
  minLenghtInventory = 3;
  errorInventoryMessage: string;

  searchText: string;
  formGroup: FormGroup;

  keywordSelected: string[];

  hasError = false;

  isDropdownClicked = false;
  isUlDropdownClicked = false;

  operator: SearchOperators;

  operators = Object.keys(SearchOperators);
  isDocout = false;

  // 🥑🥑 SRR variables para busqueda de oficina
  referenciaExterna = '';
  descriptorOficina = '';
  idGrupo: string;
  tieneBusquedaPorOficina = false;
  variableVacia = 'busquedaCompletaInventarioOficina';
  
  private subscriptionToOperators: Subscription;


  constructor(private translateService: TranslateService,
    private inventoryService: InventariosService,
    private modalservice: BsModalService,
    private toastr: ToastrService,
    private authService: AuthenticationService,
    private highlightService: HighlightService) {
    const group = {};

    const control = new FormControl(this.searchText);
    const validators = [];
    validators.push(Validators.required);
    validators.push(Validators.minLength(this.highlightService.minLenghtInventory));
    control.setValidators(validators);
    group[this.inventoryTextField] = control;
    this.formGroup = new FormGroup({
      inventoryTextField: new FormControl(''),
      chkonlyprestados: new FormControl(false)
    });
  }

  ngOnInit() {
    this.authService.isDocOutUser().then(p => this.isDocout = p.valueOf());
    this.tieneBusquedaPorOficina = this.authService.getTieneBusquedaOficina();
    this.subscriptionToOperators = this.authService.getClientSearchOperator()
      .subscribe(data => this.operator = data);
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.uldropdown.nativeElement.contains(event.target) && !event.target.hasAttribute('data-dropdown')) {
      this.checkDropdown();
    }
  }

  @HostListener('document:scroll', ['$event'])
  scrolling(event) {
    this.checkDropdown();
  }

  private checkDropdown() {
    if (this.isDropdownClicked) {
      document.body.removeChild(this.uldropdown.nativeElement);
      this.isDropdownClicked = false;
    } else {
      this.isUlDropdownClicked = false;
    }
  }

  searchInventoryText(event) {
    if (this.idGrupo == undefined || this.idGrupo == '')
    {
      if (this.formGroup.controls['inventoryTextField'].valid && this.formGroup.controls['inventoryTextField'].value == undefined)
      {
        this.toastr.warning(this.translateService.instant('generales.mensajeReferenciaExterna3') + this.descriptorOficina);
      }
      // tslint:disable-next-line: max-line-length
      else if (this.formGroup.controls['inventoryTextField'].valid && this.formGroup.controls['inventoryTextField'].value != undefined && this.formGroup.controls['inventoryTextField'].value.trim() == '')
      {
        this.toastr.warning(this.translateService.instant('generales.mensajeReferenciaExterna4') + this.descriptorOficina);
      }
      else if (this.formGroup.controls['inventoryTextField'].valid && this.formGroup.controls['inventoryTextField'].value.trim() != '')
      {
        this.keywordSelected = this.formGroup.controls['inventoryTextField'].value.split(' ').filter(search => search && search != '');

        const valueOnlyPrestado = this.formGroup.controls['chkonlyprestados'].value;
        this.searchTextFinder.emit(
          new ElasticExpedientesByKeyword(
            this.keywordSelected,
            this.operator,
            valueOnlyPrestado,
            // SRR 🥑🥑 Busqueda de inventario con referencia externa
            this.idGrupo));
        this.searchText = '';
        this.hasError = false;
        this.formGroup.controls['inventoryTextField'].markAsUntouched();

      }
      else
      {
        this.checkInventoryText();
      }
    }
    else
    {
      if (this.formGroup.controls['inventoryTextField'].valid)
      {
        if (this.formGroup.controls['inventoryTextField'].value != undefined && this.formGroup.controls['inventoryTextField'].value.trim() != '')
        {
          this.keywordSelected = this.formGroup.controls['inventoryTextField'].value.split(' ').filter(search => search && search != '');
        }
        else
        {
          this.keywordSelected = this.variableVacia.split(' ').filter(search => search && search != '');
          // tslint:disable-next-line: max-line-length
          this.toastr.info(this.translateService.instant('generales.mensajeVacioReferenciaExterna1-1') + this.descriptorOficina);
        }
        const valueOnlyPrestado = this.formGroup.controls['chkonlyprestados'].value;
        this.searchTextFinder.emit(
          new ElasticExpedientesByKeyword(
            this.keywordSelected,
            this.operator,
            valueOnlyPrestado,
            // SRR 🥑🥑 Busqueda de inventario con referencia externa
            this.idGrupo));
        this.searchText = '';
        this.hasError = false;
        this.formGroup.controls['inventoryTextField'].markAsUntouched();
      }
      else
      {
        this.checkInventoryText();
      }
    }
    this.inventorySearchInput.nativeElement.blur();
    
  }

  onFocusOut(event) {

    if (!this.searchText || this.searchText.trim() == '') {
      this.hasError = false;
      this.errorInventoryMessage = undefined;
    } else {
      this.checkInventoryText();
    }
  }

  private checkInventoryText() {
    if (this.formGroup.controls[this.inventoryTextField].hasError('required')) {
      this.hasError = true;
      this.errorInventoryMessage = this.translateService.instant('inventory.searchRequired');
    } else if (this.formGroup.controls[this.inventoryTextField].hasError('minlength')) {
      this.hasError = true;
      this.errorInventoryMessage = this.translateService.instant('inventory.minLengthErrorMessage').replace('#numberlength#', this.minLenghtInventory);
    } else {
      this.errorInventoryMessage = undefined;
      this.hasError = false;
    }
    this.formGroup.controls[this.inventoryTextField].markAsTouched();
  }

  changeFilter($event) {

  }

  isSelected(optionText: string) {
    return this.operator == SearchOperators[optionText];
  }

  selectOption(optionText: string) {
    if (this.operator != SearchOperators[optionText]) {
      this.operator = SearchOperators[optionText];
      this.inventoryService.changeSearchOperator(this.operator);
    } else {
      this.toggleDropdown();
    }
  }

  markUlDropdownTouch() {
    this.isUlDropdownClicked = true;
  }

  click() {
    this.toggleDropdown();
  }

  private toggleDropdown() {
    this.isDropdownClicked = !this.isDropdownClicked;
    this.setVisibilityUl();
    if (this.isDropdownClicked) {
      document.body.appendChild(this.uldropdown.nativeElement);
      this.absolutePosition(this.uldropdown.nativeElement, this.divDropdow.nativeElement);
    } else {
      document.body.removeChild(this.uldropdown.nativeElement);
    }
  }

  private setVisibilityUl(): any {
    this.uldropdown.nativeElement.style.display = this.isDropdownClicked ? 'block' : 'none';
  }

  private absolutePosition(element: any, target: any): void {
    const elementDimensions = element.offsetParent ? { width: element.offsetWidth, height: element.offsetHeight } : this.getHiddenElementDimensions(element);
    const elementOuterHeight = elementDimensions.height;
    const elementOuterWidth = elementDimensions.width;
    const targetOuterHeight = target.offsetHeight;
    const targetOuterWidth = target.offsetWidth;
    const targetOffset = target.getBoundingClientRect();
    const windowScrollTop = this.getWindowScrollTop();
    const windowScrollLeft = this.getWindowScrollLeft();
    const viewport = this.getViewport();
    let top, left;

    if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
      top = targetOffset.top + windowScrollTop - elementOuterHeight;
      if (top < 0) {
        top = 0 + windowScrollTop;
      }
    } else {
      top = targetOuterHeight + targetOffset.top + windowScrollTop;
    }

    if (targetOffset.left + targetOuterWidth + elementOuterWidth > viewport.width) {
      left = Math.max(0, targetOffset.left + windowScrollLeft + targetOuterWidth - elementOuterWidth);
    } else {
      left = targetOffset.left + windowScrollLeft;
    }

    element.style.top = top + 'px';
    element.style.left = left + 'px';
  }

  private getHiddenElementDimensions(element: any): any {
    const dimensions: any = {};
    element.style.visibility = 'hidden';
    element.style.display = 'block';
    dimensions.width = element.offsetWidth;
    dimensions.height = element.offsetHeight;
    element.style.display = 'none';
    element.style.visibility = 'visible';

    return dimensions;
  }

  private getWindowScrollTop(): number {
    const doc = document.documentElement;
    return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  }

  private getWindowScrollLeft(): number {
    const doc = document.documentElement;
    return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
  }

  private getViewport(): any {
    const win = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      w = win.innerWidth || e.clientWidth || g.clientWidth,
      h = win.innerHeight || e.clientHeight || g.clientHeight;

    return { width: w, height: h };
  }

  ngOnDestroy() {
    if (this.subscriptionToOperators != null) { this.subscriptionToOperators.unsubscribe(); }
  }

  // 🥑🥑🥑 Funcion para llamar al formulario final para seleccionar oficina
  preCargaModalBusquedaPorOficina() {
          // Modal
    this.showModalIndicarOficinaBusqueda();
  }

  // 🥑🥑 Carga modal para indicar oficina
  showModalIndicarOficinaBusqueda() {
    // const modal = this.modalservice.show(BusquedaOficinaComponent, { backdrop: 'static', keyboard: false, class: 'modal-lg' });
    const modal = this.modalservice.show(BusquedaOficinaComponent, { backdrop: 'static', keyboard: false});

    (<BusquedaOficinaComponent>modal.content).showConfirmationModal(
      this.referenciaExterna, this.descriptorOficina
    );
    (<BusquedaOficinaComponent>modal.content).onSaveCambios.subscribe(datos => {
      if (datos != null) {
        this.referenciaExterna = datos.REFERENCIA_EXTERNA;
        this.idGrupo = datos.ID_GRUPO;
        this.descriptorOficina = datos.REFERENCIA_EXTERNA + '-' + datos.DESCRIPCION;
        if (this.descriptorOficina.length > 50) {
          this.descriptorOficina = this.descriptorOficina.substr(1, 50) + '...';
          }
      }
    });
    (<BusquedaOficinaComponent>modal.content).onQuitar.subscribe(result => {
      if (result) {
        this.onQuitarOficina();
        return;
      }
    });
    (<BusquedaOficinaComponent>modal.content).onClose.subscribe(result => {
      if (!result) {
        return;
      }
    });
  }

  // 🥑🥑 Funcion para quitar el filtro de la oficina
  onQuitarOficina() {
    this.toastr.info('Se ha eliminado el filtro de la oficina para la búsqueda de inventario.');
    this.referenciaExterna = '';
    this.descriptorOficina = '';
    this.idGrupo = '';
  }


}
